const EMAIL_CONFIRMATION_ERROR_MATCHERS = [
  "email not confirmed",
  "email address not authorized",
  "confirm your email",
];

export const EMAIL_CONFIRMATION_SIGNUP_WEB_MESSAGE =
  "Account created. Check your email to confirm your address before signing in.";

export const EMAIL_CONFIRMATION_SIGNUP_MOBILE_MESSAGE =
  "Your account is ready. Open the confirmation email on this device, then come back to Kindred to sign in.";

export const EMAIL_CONFIRMATION_SIGNIN_MESSAGE =
  "Please confirm your email before signing in. Check your inbox for Kindred's confirmation email.";

export function isEmailConfirmationRequiredError(error: unknown): boolean {
  const message =
    typeof error === "string"
      ? error
      : error && typeof error === "object" && "message" in error
        ? String(error.message ?? "")
        : "";

  const normalizedMessage = message.trim().toLowerCase();

  return EMAIL_CONFIRMATION_ERROR_MATCHERS.some((fragment) => normalizedMessage.includes(fragment));
}
